import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "@/config/authConfig";
import { AuthGuard } from "@/components/AuthGuard";
import Login from "./pages/Login";
import RequestAccess from "./pages/RequestAccess";
import VerifyOTP from "./pages/VerifyOTP";
import NotFound from "./pages/NotFound";
import { ThemeProvider } from "@/components/theme-provider";
import Profile from "./pages/Profile";
import Home from "./pages/Home";

import PageLayout from "./layouts/PageLayout";
import AuthLayout from "./layouts/AuthLayout";

const queryClient = new QueryClient();
const msalInstance = new PublicClientApplication(msalConfig);

const App = () => (
  <MsalProvider instance={msalInstance}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <AuthGuard>
              <Routes>
                <Route element={<AuthLayout />}>
                  <Route path="/" element={<Login />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/request-access" element={<RequestAccess />} />
                  <Route path="/verify-otp" element={<VerifyOTP />} />
                </Route>
                <Route element={<PageLayout />}>
                  <Route path="/home" element={<Home />} />
                  <Route path="/me" element={<Profile />} />
                </Route>

                <Route path="*" element={<NotFound />} />
              </Routes>
            </AuthGuard>
          </BrowserRouter>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </MsalProvider>
);

export default App;
